import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { LandingRoutingModule } from './landing-routing.module';
import { LandingComponent } from './components/landing.component';

import { SharedModule } from '../shared/module';

@NgModule({
  imports: [
    BrowserModule,
    LandingRoutingModule,
    SharedModule
  ],
  declarations: [
    LandingComponent
  ],
  exports: [],
  providers: [],
})
export class LandingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/landing/landing.module.ts